import * as angular from 'angular';


export class AncillariesPreorderTransformer {
    constructor (
        private AncillariesConstants: AncillariesConstant,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private CurrencyService: CurrencyService
    ) {}

    generatePreorderInfo = (ancillary: any, transformedInfo: any) => {
        const preOrderConfig = {
            currency: ancillary.currency,
            info: ancillary.externalUrl,
            priceFrom: '',
            status: ancillary.status,
            type: ancillary.type,
            name: this.AncillariesConstants.PREORDER_CONFIGURATION.NAME,
            cardCols: this.AncillariesConstants.PREORDER_CONFIGURATION.CARDCOLS,
            cardType: this.AncillariesConstants.PREORDER_CONFIGURATION.CARDTYPE,
            cardImg: this.AncillariesConstants.PREORDER_CONFIGURATION.CARDIMG,
            cardTitle: this.AncillariesConstants.PREORDER_CONFIGURATION.CARDTITLE,
            cardText: this.AncillariesConstants.PREORDER_CONFIGURATION.CARDTEXT,
            cardSubtext: this.AncillariesConstants.PREORDER_CONFIGURATION.CARDSUBTEXT,
            cardSubtextSelect: this.AncillariesConstants.PREORDER_CONFIGURATION.CARDSUBTEXTSELECT,
            cardButton: this.AncillariesConstants.PREORDER_CONFIGURATION.CARDBUTTON,
            confirmed: this.localStorageService.get('hasPreorderAncillarie'),
            selectedFlex: null,
            modal: this.AncillariesConstants.PREORDER_CONFIGURATION.MODAL,
            datalayer: this.AncillariesConstants.DATALAYER_INFO.PREORDER_DISPLAY,
            cardPriceFormatted: this.CurrencyService.formatPrice(transformedInfo.currency, Math.floor(parseFloat(this.AncillariesConstants.PREORDER_CONFIGURATION.CARDPRICE)), false, false)
        };
        return preOrderConfig;
    };
}

AncillariesPreorderTransformer.$inject = ['AncillariesConstants', 'localStorageService', 'CurrencyService'];
try {
    const mod = angular.module('ib-web-ancillaries-module');
    mod.service('AncillariesPreorderTransformer', AncillariesPreorderTransformer);
} catch (error) {
    const mod = angular.module('ib-web-ancillaries-module', []);
    mod.service('AncillariesPreorderTransformer', AncillariesPreorderTransformer);
}
